import { ReactElement } from "react";
import {
	ListItem,
	PersonAvatar,
	PersonAvatarStatusKind
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { getContactPhotoUrl } from "client/Features/AddressBook/common";
import { AttendingStatus } from "client/Api/Calendar/calendar";
import { isNotNil } from "client/Misc/utils";
import styles from "./AppointmentAttendeeListItem.module.less";
import classNames from "classnames";

export type AppointmentAttendeeListItemProps = {
	displayName: string;
	emailAddress?: string;
	isOrganizer?: boolean;
	status?: AttendingStatus;
	trackingId?: string;
};

export const AppointmentAttendeeListitem = (props: AppointmentAttendeeListItemProps): ReactElement => {
	const {
		displayName,
		emailAddress,
		isOrganizer = false,
		status,
		trackingId
	} = props;

	return (
		<li>
			<ListItem
				trackingId={trackingId}
				interactionMode="none"
				noMobileBorderBottom
			>
				<ListItem.Content
					thumbnail={
						<PersonAvatar
							initials={displayName && displayName.length > 0 ? displayName[0] : ""}
							imageSrc={emailAddress ? getContactPhotoUrl(emailAddress) : undefined}
							status={isNotNil(status)
								? {
									kind: "status",
									status: statusToAvatarStatusMap[status]
								}
								: undefined
							}
						/>
					}
				>
					<ListItem.Title
						trackingId="title"
					>
						{ displayName } { isOrganizer && `(${localize("_Organiser")})`}
					</ListItem.Title>
					{isNotNil(status) && (
						<ListItem.SubTitle
							trackingId="subtitle"
						>
							<span className={classNames(
								attendingStatusToSubtitleStylesMap[status]
							)}>
								{localize(attendingStatusToSubtitleLocalizationKey[status])}
							</span>
						</ListItem.SubTitle>
					)}
				</ListItem.Content>
			</ListItem>
		</li>
	);
};
AppointmentAttendeeListitem.displayName = "AppointmentAttendeeListitem";

const statusToAvatarStatusMap: { [key in AttendingStatus]: PersonAvatarStatusKind | undefined } = {
	[AttendingStatus.Unknown]: PersonAvatarStatusKind.Unknown,
	[AttendingStatus.Accept]: PersonAvatarStatusKind.Accept,
	[AttendingStatus.Decline]: PersonAvatarStatusKind.Decline,
	[AttendingStatus.Tenative]: PersonAvatarStatusKind.Tenative,
};

const attendingStatusToSubtitleStylesMap: { [key in AttendingStatus]: string } = {
	[AttendingStatus.Accept]: styles.subtitle_accept,
	[AttendingStatus.Unknown]: styles.subtitle_unknown,
	[AttendingStatus.Decline]: styles.subtitle_decline,
	[AttendingStatus.Tenative]: styles.subtitle_tenative
};

const attendingStatusToSubtitleLocalizationKey: { [key in AttendingStatus]: LocalizationKey } = {
	[AttendingStatus.Accept]: "_Accepted",
	[AttendingStatus.Unknown]: "_NotResponded",
	[AttendingStatus.Decline]: "_Declined",
	[AttendingStatus.Tenative]: "_Tentative"
};
